// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetMarketTickers (params?: {}): Promise<Dict>;
    publicGetMarketTicker (params?: {}): Promise<Dict>;
    publicGetMarketBooks (params?: {}): Promise<Dict>;
    publicGetMarketBooksFull (params?: {}): Promise<Dict>;
    publicGetMarketBooksRpi (params?: {}): Promise<Dict>;
    publicGetMarketCandles (params?: {}): Promise<Dict>;
    publicGetMarketHistoryCandles (params?: {}): Promise<Dict>;
    publicGetMarketTrades (params?: {}): Promise<Dict>;
    publicGetMarketHistoryTrades (params?: {}): Promise<Dict>;
    publicGetMarketOptionInstrumentFamilyTrades (params?: {}): Promise<Dict>;
    publicGetMarketPlatform24Volume (params?: {}): Promise<Dict>;
    publicGetMarketCallAuctionDetail (params?: {}): Promise<Dict>;
    publicGetMarketCallAuctionDetails (params?: {}): Promise<Dict>;
    publicGetMarketBooksSbe (params?: {}): Promise<Dict>;
    publicGetMarketBlockTickers (params?: {}): Promise<Dict>;
    publicGetMarketBlockTicker (params?: {}): Promise<Dict>;
    publicGetMarketSprdTicker (params?: {}): Promise<Dict>;
    publicGetMarketSprdCandles (params?: {}): Promise<Dict>;
    publicGetMarketSprdHistoryCandles (params?: {}): Promise<Dict>;
    publicGetMarketIndexTickers (params?: {}): Promise<Dict>;
    publicGetMarketIndexCandles (params?: {}): Promise<Dict>;
    publicGetMarketHistoryIndexCandles (params?: {}): Promise<Dict>;
    publicGetMarketMarkPriceCandles (params?: {}): Promise<Dict>;
    publicGetMarketHistoryMarkPriceCandles (params?: {}): Promise<Dict>;
    publicGetMarketExchangeRate (params?: {}): Promise<Dict>;
    publicGetMarketIndexComponents (params?: {}): Promise<Dict>;
    publicGetMarketOpenOracle (params?: {}): Promise<Dict>;
    publicGetMarketBooksLite (params?: {}): Promise<Dict>;
    publicGetPublicOptionTrades (params?: {}): Promise<Dict>;
    publicGetPublicBlockTrades (params?: {}): Promise<Dict>;
    publicGetPublicInstruments (params?: {}): Promise<Dict>;
    publicGetPublicEstimatedPrice (params?: {}): Promise<Dict>;
    publicGetPublicDeliveryExerciseHistory (params?: {}): Promise<Dict>;
    publicGetPublicEstimatedSettlementInfo (params?: {}): Promise<Dict>;
    publicGetPublicSettlementHistory (params?: {}): Promise<Dict>;
    publicGetPublicFundingRate (params?: {}): Promise<Dict>;
    publicGetPublicFundingRateHistory (params?: {}): Promise<Dict>;
    publicGetPublicOpenInterest (params?: {}): Promise<Dict>;
    publicGetPublicPriceLimit (params?: {}): Promise<Dict>;
    publicGetPublicOptSummary (params?: {}): Promise<Dict>;
    publicGetPublicDiscountRateInterestFreeQuota (params?: {}): Promise<Dict>;
    publicGetPublicTime (params?: {}): Promise<Dict>;
    publicGetPublicMarkPrice (params?: {}): Promise<Dict>;
    publicGetPublicPositionTiers (params?: {}): Promise<Dict>;
    publicGetPublicInterestRateLoanQuota (params?: {}): Promise<Dict>;
    publicGetPublicUnderlying (params?: {}): Promise<Dict>;
    publicGetPublicInsuranceFund (params?: {}): Promise<Dict>;
    publicGetPublicConvertContractCoin (params?: {}): Promise<Dict>;
    publicGetPublicInstrumentTickBands (params?: {}): Promise<Dict>;
    publicGetPublicPremiumHistory (params?: {}): Promise<Dict>;
    publicGetPublicEconomicCalendar (params?: {}): Promise<Dict>;
    publicGetPublicMarketDataHistory (params?: {}): Promise<Dict>;
    publicGetPublicEventContractEvents (params?: {}): Promise<Dict>;
    publicGetPublicEventContractMarkets (params?: {}): Promise<Dict>;
    publicGetPublicEventContractSeries (params?: {}): Promise<Dict>;
    publicGetPublicVipInterestRateLoanQuota (params?: {}): Promise<Dict>;
    publicGetPublicMmInstrumentTypes (params?: {}): Promise<Dict>;
    publicGetPublicDeltaHedgeCurrencies (params?: {}): Promise<Dict>;
    publicGetRubikStatTradingDataSupportCoin (params?: {}): Promise<Dict>;
    publicGetRubikStatContractsOpenInterestHistory (params?: {}): Promise<Dict>;
    publicGetRubikStatTakerVolume (params?: {}): Promise<Dict>;
    publicGetRubikStatTakerVolumeContract (params?: {}): Promise<Dict>;
    publicGetRubikStatMarginLoanRatio (params?: {}): Promise<Dict>;
    publicGetRubikStatContractsLongShortAccountRatioContractTopTrader (params?: {}): Promise<Dict>;
    publicGetRubikStatContractsLongShortPositionRatioContractTopTrader (params?: {}): Promise<Dict>;
    publicGetRubikStatContractsLongShortAccountRatioContract (params?: {}): Promise<Dict>;
    publicGetRubikStatContractsLongShortAccountRatio (params?: {}): Promise<Dict>;
    publicGetRubikStatContractsOpenInterestVolume (params?: {}): Promise<Dict>;
    publicGetRubikStatOptionOpenInterestVolume (params?: {}): Promise<Dict>;
    publicGetRubikStatOptionOpenInterestVolumeRatio (params?: {}): Promise<Dict>;
    publicGetRubikStatOptionOpenInterestVolumeExpiry (params?: {}): Promise<Dict>;
    publicGetRubikStatOptionOpenInterestVolumeStrike (params?: {}): Promise<Dict>;
    publicGetRubikStatOptionTakerBlockVolume (params?: {}): Promise<Dict>;
    publicGetSystemStatus (params?: {}): Promise<Dict>;
    publicGetSprdSpreads (params?: {}): Promise<Dict>;
    publicGetSprdBooks (params?: {}): Promise<Dict>;
    publicGetSprdPublicTrades (params?: {}): Promise<Dict>;
    publicGetSprdTicker (params?: {}): Promise<Dict>;
    publicGetTradingBotGridAiParam (params?: {}): Promise<Dict>;
    publicGetTradingBotGridMinInvestment (params?: {}): Promise<Dict>;
    publicGetTradingBotPublicRsiBackTesting (params?: {}): Promise<Dict>;
    publicGetTradingBotGridGridQuantity (params?: {}): Promise<Dict>;
    publicGetAssetExchangeList (params?: {}): Promise<Dict>;
    publicGetFinanceStakingDefiEthApyHistory (params?: {}): Promise<Dict>;
    publicGetFinanceStakingDefiSolApyHistory (params?: {}): Promise<Dict>;
    publicGetFinanceSavingsLendingRateSummary (params?: {}): Promise<Dict>;
    publicGetFinanceSavingsLendingRateHistory (params?: {}): Promise<Dict>;
    publicGetFinanceFixedLoanLendingOffers (params?: {}): Promise<Dict>;
    publicGetFinanceFixedLoanLendingApyHistory (params?: {}): Promise<Dict>;
    publicGetFinanceFixedLoanPendingLendingVolume (params?: {}): Promise<Dict>;
    publicGetFinanceSfpDcdProducts (params?: {}): Promise<Dict>;
    publicGetCopytradingPublicConfig (params?: {}): Promise<Dict>;
    publicGetCopytradingPublicLeadTraders (params?: {}): Promise<Dict>;
    publicGetCopytradingPublicWeeklyPnl (params?: {}): Promise<Dict>;
    publicGetCopytradingPublicPnl (params?: {}): Promise<Dict>;
    publicGetCopytradingPublicStats (params?: {}): Promise<Dict>;
    publicGetCopytradingPublicPreferenceCurrency (params?: {}): Promise<Dict>;
    publicGetCopytradingPublicCurrentSubpositions (params?: {}): Promise<Dict>;
    publicGetCopytradingPublicSubpositionsHistory (params?: {}): Promise<Dict>;
    publicGetCopytradingPublicCopyTraders (params?: {}): Promise<Dict>;
    publicGetSupportAnnouncements (params?: {}): Promise<Dict>;
    publicGetSupportAnnouncementsTypes (params?: {}): Promise<Dict>;
    publicGetSupportAnnouncementTypes (params?: {}): Promise<Dict>;
    publicPostTradingBotGridMinInvestment (params?: {}): Promise<Dict>;
    privateGetRfqCounterparties (params?: {}): Promise<Dict>;
    privateGetRfqMakerInstrumentSettings (params?: {}): Promise<Dict>;
    privateGetRfqMmpConfig (params?: {}): Promise<Dict>;
    privateGetRfqRfqs (params?: {}): Promise<Dict>;
    privateGetRfqQuotes (params?: {}): Promise<Dict>;
    privateGetRfqTrades (params?: {}): Promise<Dict>;
    privateGetRfqPublicTrades (params?: {}): Promise<Dict>;
    privateGetSprdOrder (params?: {}): Promise<Dict>;
    privateGetSprdOrdersPending (params?: {}): Promise<Dict>;
    privateGetSprdOrdersHistory (params?: {}): Promise<Dict>;
    privateGetSprdOrdersHistoryArchive (params?: {}): Promise<Dict>;
    privateGetSprdTrades (params?: {}): Promise<Dict>;
    privateGetTradeOrder (params?: {}): Promise<Dict>;
    privateGetTradeOrdersPending (params?: {}): Promise<Dict>;
    privateGetTradeOrdersHistory (params?: {}): Promise<Dict>;
    privateGetTradeOrdersHistoryArchive (params?: {}): Promise<Dict>;
    privateGetTradeFills (params?: {}): Promise<Dict>;
    privateGetTradeFillsHistory (params?: {}): Promise<Dict>;
    privateGetTradeFillsArchive (params?: {}): Promise<Dict>;
    privateGetTradeOrderAlgo (params?: {}): Promise<Dict>;
    privateGetTradeOrdersAlgoPending (params?: {}): Promise<Dict>;
    privateGetTradeOrdersAlgoHistory (params?: {}): Promise<Dict>;
    privateGetTradeEasyConvertCurrencyList (params?: {}): Promise<Dict>;
    privateGetTradeEasyConvertHistory (params?: {}): Promise<Dict>;
    privateGetTradeOneClickRepayCurrencyList (params?: {}): Promise<Dict>;
    privateGetTradeOneClickRepayCurrencyListV2 (params?: {}): Promise<Dict>;
    privateGetTradeOneClickRepayHistory (params?: {}): Promise<Dict>;
    privateGetTradeOneClickRepayHistoryV2 (params?: {}): Promise<Dict>;
    privateGetTradeAccountRateLimit (params?: {}): Promise<Dict>;
    privateGetAssetCurrencies (params?: {}): Promise<Dict>;
    privateGetAssetBalances (params?: {}): Promise<Dict>;
    privateGetAssetNonTradableAssets (params?: {}): Promise<Dict>;
    privateGetAssetAssetValuation (params?: {}): Promise<Dict>;
    privateGetAssetTransferState (params?: {}): Promise<Dict>;
    privateGetAssetBills (params?: {}): Promise<Dict>;
    privateGetAssetBillsHistory (params?: {}): Promise<Dict>;
    privateGetAssetDepositLightning (params?: {}): Promise<Dict>;
    privateGetAssetDepositAddress (params?: {}): Promise<Dict>;
    privateGetAssetDepositHistory (params?: {}): Promise<Dict>;
    privateGetAssetWithdrawalHistory (params?: {}): Promise<Dict>;
    privateGetAssetDepositWithdrawStatus (params?: {}): Promise<Dict>;
    privateGetAssetMonthlyStatement (params?: {}): Promise<Dict>;
    privateGetAssetConvertCurrencies (params?: {}): Promise<Dict>;
    privateGetAssetConvertCurrencyPair (params?: {}): Promise<Dict>;
    privateGetAssetConvertHistory (params?: {}): Promise<Dict>;
    privateGetFiatDepositPaymentMethods (params?: {}): Promise<Dict>;
    privateGetFiatWithdrawalPaymentMethods (params?: {}): Promise<Dict>;
    privateGetFiatDepositOrderHistory (params?: {}): Promise<Dict>;
    privateGetFiatDeposit (params?: {}): Promise<Dict>;
    privateGetFiatWithdrawalOrderHistory (params?: {}): Promise<Dict>;
    privateGetFiatWithdrawal (params?: {}): Promise<Dict>;
    privateGetFiatBuySellCurrencies (params?: {}): Promise<Dict>;
    privateGetFiatBuySellCurrencyPair (params?: {}): Promise<Dict>;
    privateGetFiatBuySellHistory (params?: {}): Promise<Dict>;
    privateGetAccountInstruments (params?: {}): Promise<Dict>;
    privateGetAccountBalance (params?: {}): Promise<Dict>;
    privateGetAccountPositions (params?: {}): Promise<Dict>;
    privateGetAccountPositionsHistory (params?: {}): Promise<Dict>;
    privateGetAccountAccountPositionRisk (params?: {}): Promise<Dict>;
    privateGetAccountBills (params?: {}): Promise<Dict>;
    privateGetAccountBillsArchive (params?: {}): Promise<Dict>;
    privateGetAccountBillsHistoryArchive (params?: {}): Promise<Dict>;
    privateGetAccountConfig (params?: {}): Promise<Dict>;
    privateGetAccountSubtypes (params?: {}): Promise<Dict>;
    privateGetAccountMaxSize (params?: {}): Promise<Dict>;
    privateGetAccountMaxAvailSize (params?: {}): Promise<Dict>;
    privateGetAccountLeverageInfo (params?: {}): Promise<Dict>;
    privateGetAccountAdjustLeverageInfo (params?: {}): Promise<Dict>;
    privateGetAccountMaxLoan (params?: {}): Promise<Dict>;
    privateGetAccountTradeFee (params?: {}): Promise<Dict>;
    privateGetAccountInterestAccrued (params?: {}): Promise<Dict>;
    privateGetAccountInterestRate (params?: {}): Promise<Dict>;
    privateGetAccountMaxWithdrawal (params?: {}): Promise<Dict>;
    privateGetAccountRiskState (params?: {}): Promise<Dict>;
    privateGetAccountInterestLimits (params?: {}): Promise<Dict>;
    privateGetAccountSpotBorrowRepayHistory (params?: {}): Promise<Dict>;
    privateGetAccountGreeks (params?: {}): Promise<Dict>;
    privateGetAccountPositionTiers (params?: {}): Promise<Dict>;
    privateGetAccountSetAccountSwitchPrecheck (params?: {}): Promise<Dict>;
    privateGetAccountCollateralAssets (params?: {}): Promise<Dict>;
    privateGetAccountMmpConfig (params?: {}): Promise<Dict>;
    privateGetAccountMovePositionsHistory (params?: {}): Promise<Dict>;
    privateGetAccountPrecheckSetDeltaNeutral (params?: {}): Promise<Dict>;
    privateGetAccountQuickMarginBorrowRepayHistory (params?: {}): Promise<Dict>;
    privateGetAccountBorrowRepayHistory (params?: {}): Promise<Dict>;
    privateGetAccountVipInterestAccrued (params?: {}): Promise<Dict>;
    privateGetAccountVipInterestDeducted (params?: {}): Promise<Dict>;
    privateGetAccountVipLoanOrderList (params?: {}): Promise<Dict>;
    privateGetAccountVipLoanOrderDetail (params?: {}): Promise<Dict>;
    privateGetAccountFixedLoanBorrowingLimit (params?: {}): Promise<Dict>;
    privateGetAccountFixedLoanBorrowingQuote (params?: {}): Promise<Dict>;
    privateGetAccountFixedLoanBorrowingOrdersList (params?: {}): Promise<Dict>;
    privateGetAccountSpotManualBorrowRepay (params?: {}): Promise<Dict>;
    privateGetAccountSetAutoRepay (params?: {}): Promise<Dict>;
    privateGetUsersSubaccountList (params?: {}): Promise<Dict>;
    privateGetAccountSubaccountBalances (params?: {}): Promise<Dict>;
    privateGetAssetSubaccountBalances (params?: {}): Promise<Dict>;
    privateGetAccountSubaccountMaxWithdrawal (params?: {}): Promise<Dict>;
    privateGetAssetSubaccountBills (params?: {}): Promise<Dict>;
    privateGetAssetSubaccountManagedSubaccountBills (params?: {}): Promise<Dict>;
    privateGetUsersEntrustSubaccountList (params?: {}): Promise<Dict>;
    privateGetAccountSubaccountInterestLimits (params?: {}): Promise<Dict>;
    privateGetUsersSubaccountApikey (params?: {}): Promise<Dict>;
    privateGetTradingBotGridOrdersAlgoPending (params?: {}): Promise<Dict>;
    privateGetTradingBotGridOrdersAlgoHistory (params?: {}): Promise<Dict>;
    privateGetTradingBotGridOrdersAlgoDetails (params?: {}): Promise<Dict>;
    privateGetTradingBotGridSubOrders (params?: {}): Promise<Dict>;
    privateGetTradingBotGridPositions (params?: {}): Promise<Dict>;
    privateGetTradingBotGridAiParam (params?: {}): Promise<Dict>;
    privateGetTradingBotSignalSignals (params?: {}): Promise<Dict>;
    privateGetTradingBotSignalOrdersAlgoDetails (params?: {}): Promise<Dict>;
    privateGetTradingBotSignalOrdersAlgoPending (params?: {}): Promise<Dict>;
    privateGetTradingBotSignalOrdersAlgoHistory (params?: {}): Promise<Dict>;
    privateGetTradingBotSignalPositions (params?: {}): Promise<Dict>;
    privateGetTradingBotSignalPositionsHistory (params?: {}): Promise<Dict>;
    privateGetTradingBotSignalSubOrders (params?: {}): Promise<Dict>;
    privateGetTradingBotSignalEventHistory (params?: {}): Promise<Dict>;
    privateGetTradingBotRecurringOrdersAlgoPending (params?: {}): Promise<Dict>;
    privateGetTradingBotRecurringOrdersAlgoHistory (params?: {}): Promise<Dict>;
    privateGetTradingBotRecurringOrdersAlgoDetails (params?: {}): Promise<Dict>;
    privateGetTradingBotRecurringSubOrders (params?: {}): Promise<Dict>;
    privateGetTradingBotDcaOngoingList (params?: {}): Promise<Dict>;
    privateGetTradingBotDcaHistoryList (params?: {}): Promise<Dict>;
    privateGetTradingBotDcaOrders (params?: {}): Promise<Dict>;
    privateGetTradingBotDcaPositionDetails (params?: {}): Promise<Dict>;
    privateGetTradingBotDcaCycleList (params?: {}): Promise<Dict>;
    privateGetFinanceSavingsBalance (params?: {}): Promise<Dict>;
    privateGetFinanceSavingsLendingHistory (params?: {}): Promise<Dict>;
    privateGetFinanceStakingDefiOffers (params?: {}): Promise<Dict>;
    privateGetFinanceStakingDefiOrdersActive (params?: {}): Promise<Dict>;
    privateGetFinanceStakingDefiOrdersHistory (params?: {}): Promise<Dict>;
    privateGetFinanceStakingDefiEthProductInfo (params?: {}): Promise<Dict>;
    privateGetFinanceStakingDefiEthBalance (params?: {}): Promise<Dict>;
    privateGetFinanceStakingDefiEthPurchaseRedeemHistory (params?: {}): Promise<Dict>;
    privateGetFinanceStakingDefiSolProductInfo (params?: {}): Promise<Dict>;
    privateGetFinanceStakingDefiSolBalance (params?: {}): Promise<Dict>;
    privateGetFinanceStakingDefiSolPurchaseRedeemHistory (params?: {}): Promise<Dict>;
    privateGetFinanceFlexibleLoanBorrowCurrencies (params?: {}): Promise<Dict>;
    privateGetFinanceFlexibleLoanCollateralAssets (params?: {}): Promise<Dict>;
    privateGetFinanceFlexibleLoanMaxCollateralRedeemAmount (params?: {}): Promise<Dict>;
    privateGetFinanceFlexibleLoanLoanInfo (params?: {}): Promise<Dict>;
    privateGetFinanceFlexibleLoanLoanHistory (params?: {}): Promise<Dict>;
    privateGetFinanceFlexibleLoanInterestAccrued (params?: {}): Promise<Dict>;
    privateGetFinanceFlexibleLoanEmodeInfo (params?: {}): Promise<Dict>;
    privateGetFinanceOkusdLimits (params?: {}): Promise<Dict>;
    privateGetFinanceOkusdAccount (params?: {}): Promise<Dict>;
    privateGetFinanceOkusdSubscribeHistory (params?: {}): Promise<Dict>;
    privateGetFinanceOkusdRedeemHistory (params?: {}): Promise<Dict>;
    privateGetFinanceOkusdRewardsHistory (params?: {}): Promise<Dict>;
    privateGetFinanceOkusdRateHistory (params?: {}): Promise<Dict>;
    privateGetFinanceStableRewardsProductInfo (params?: {}): Promise<Dict>;
    privateGetFinanceStableRewardsBalance (params?: {}): Promise<Dict>;
    privateGetFinanceStableRewardsApyHistory (params?: {}): Promise<Dict>;
    privateGetUsersGlpTodayperformance (params?: {}): Promise<Dict>;
    privateGetUsersGlpHistoricalperformance (params?: {}): Promise<Dict>;
    privateGetCopytradingCurrentSubpositions (params?: {}): Promise<Dict>;
    privateGetCopytradingSubpositionsHistory (params?: {}): Promise<Dict>;
    privateGetCopytradingInstruments (params?: {}): Promise<Dict>;
    privateGetCopytradingProfitSharingDetails (params?: {}): Promise<Dict>;
    privateGetCopytradingTotalProfitSharing (params?: {}): Promise<Dict>;
    privateGetCopytradingUnrealizedProfitSharingDetails (params?: {}): Promise<Dict>;
    privateGetCopytradingTotalUnrealizedProfitSharing (params?: {}): Promise<Dict>;
    privateGetCopytradingConfig (params?: {}): Promise<Dict>;
    privateGetCopytradingCopySettings (params?: {}): Promise<Dict>;
    privateGetCopytradingCurrentLeadTraders (params?: {}): Promise<Dict>;
    privateGetCopytradingBatchLeverageInfo (params?: {}): Promise<Dict>;
    privateGetCopytradingLeadTradersHistory (params?: {}): Promise<Dict>;
    privateGetBrokerDmaSubaccountInfo (params?: {}): Promise<Dict>;
    privateGetBrokerDmaSubaccountTradeFee (params?: {}): Promise<Dict>;
    privateGetBrokerDmaSubaccountApikey (params?: {}): Promise<Dict>;
    privateGetBrokerDmaRebatePerOrders (params?: {}): Promise<Dict>;
    privateGetBrokerFdRebatePerOrders (params?: {}): Promise<Dict>;
    privateGetBrokerFdIfRebate (params?: {}): Promise<Dict>;
    privateGetBrokerNdInfo (params?: {}): Promise<Dict>;
    privateGetBrokerNdSubaccountInfo (params?: {}): Promise<Dict>;
    privateGetBrokerNdSubaccountApikey (params?: {}): Promise<Dict>;
    privateGetAssetBrokerNdSubaccountDepositAddress (params?: {}): Promise<Dict>;
    privateGetAssetBrokerNdSubaccountDepositHistory (params?: {}): Promise<Dict>;
    privateGetAssetBrokerNdSubaccountWithdrawalHistory (params?: {}): Promise<Dict>;
    privateGetBrokerNdRebateDaily (params?: {}): Promise<Dict>;
    privateGetBrokerNdRebatePerOrders (params?: {}): Promise<Dict>;
    privateGetFinanceSfpDcdOrder (params?: {}): Promise<Dict>;
    privateGetFinanceSfpDcdOrders (params?: {}): Promise<Dict>;
    privateGetFinanceSfpDcdCurrencyPair (params?: {}): Promise<Dict>;
    privateGetFinanceSfpDcdOrderStatus (params?: {}): Promise<Dict>;
    privateGetFinanceSfpDcdOrderHistory (params?: {}): Promise<Dict>;
    privateGetAffiliateInviteeDetail (params?: {}): Promise<Dict>;
    privateGetAffiliatePerformanceSummary (params?: {}): Promise<Dict>;
    privateGetAffiliateInviteeList (params?: {}): Promise<Dict>;
    privateGetAffiliateLinkList (params?: {}): Promise<Dict>;
    privateGetAffiliateCoInviterList (params?: {}): Promise<Dict>;
    privateGetAffiliateSubAffiliateList (params?: {}): Promise<Dict>;
    privateGetUsersPartnerIfRebate (params?: {}): Promise<Dict>;
    privateGetSupportAnnouncements (params?: {}): Promise<Dict>;
    privatePostRfqCreateRfq (params?: {}): Promise<Dict>;
    privatePostRfqCancelRfq (params?: {}): Promise<Dict>;
    privatePostRfqCancelBatchRfqs (params?: {}): Promise<Dict>;
    privatePostRfqCancelAllRfqs (params?: {}): Promise<Dict>;
    privatePostRfqExecuteQuote (params?: {}): Promise<Dict>;
    privatePostRfqMakerInstrumentSettings (params?: {}): Promise<Dict>;
    privatePostRfqMmpReset (params?: {}): Promise<Dict>;
    privatePostRfqMmpConfig (params?: {}): Promise<Dict>;
    privatePostRfqCreateQuote (params?: {}): Promise<Dict>;
    privatePostRfqCancelQuote (params?: {}): Promise<Dict>;
    privatePostRfqCancelBatchQuotes (params?: {}): Promise<Dict>;
    privatePostRfqCancelAllQuotes (params?: {}): Promise<Dict>;
    privatePostRfqCancelAllAfter (params?: {}): Promise<Dict>;
    privatePostSprdOrder (params?: {}): Promise<Dict>;
    privatePostSprdCancelOrder (params?: {}): Promise<Dict>;
    privatePostSprdMassCancel (params?: {}): Promise<Dict>;
    privatePostSprdAmendOrder (params?: {}): Promise<Dict>;
    privatePostSprdCancelAllAfter (params?: {}): Promise<Dict>;
    privatePostTradeOrder (params?: {}): Promise<Dict>;
    privatePostTradeBatchOrders (params?: {}): Promise<Dict>;
    privatePostTradeCancelOrder (params?: {}): Promise<Dict>;
    privatePostTradeCancelBatchOrders (params?: {}): Promise<Dict>;
    privatePostTradeAmendOrder (params?: {}): Promise<Dict>;
    privatePostTradeAmendBatchOrders (params?: {}): Promise<Dict>;
    privatePostTradeClosePosition (params?: {}): Promise<Dict>;
    privatePostTradeFillsArchive (params?: {}): Promise<Dict>;
    privatePostTradeCancelAdvanceAlgos (params?: {}): Promise<Dict>;
    privatePostTradeEasyConvert (params?: {}): Promise<Dict>;
    privatePostTradeOneClickRepay (params?: {}): Promise<Dict>;
    privatePostTradeOneClickRepayV2 (params?: {}): Promise<Dict>;
    privatePostTradeMassCancel (params?: {}): Promise<Dict>;
    privatePostTradeCancelAllAfter (params?: {}): Promise<Dict>;
    privatePostTradeOrderPrecheck (params?: {}): Promise<Dict>;
    privatePostTradeOrderAlgo (params?: {}): Promise<Dict>;
    privatePostTradeCancelAlgos (params?: {}): Promise<Dict>;
    privatePostTradeAmendAlgos (params?: {}): Promise<Dict>;
    privatePostAssetTransfer (params?: {}): Promise<Dict>;
    privatePostAssetWithdrawal (params?: {}): Promise<Dict>;
    privatePostAssetWithdrawalLightning (params?: {}): Promise<Dict>;
    privatePostAssetCancelWithdrawal (params?: {}): Promise<Dict>;
    privatePostAssetConvertDustAssets (params?: {}): Promise<Dict>;
    privatePostAssetMonthlyStatement (params?: {}): Promise<Dict>;
    privatePostAssetConvertEstimateQuote (params?: {}): Promise<Dict>;
    privatePostAssetConvertTrade (params?: {}): Promise<Dict>;
    privatePostFiatCreateWithdrawal (params?: {}): Promise<Dict>;
    privatePostFiatCancelWithdrawal (params?: {}): Promise<Dict>;
    privatePostFiatBuySellQuote (params?: {}): Promise<Dict>;
    privatePostFiatBuySellTrade (params?: {}): Promise<Dict>;
    privatePostAccountBillsHistoryArchive (params?: {}): Promise<Dict>;
    privatePostAccountSetPositionMode (params?: {}): Promise<Dict>;
    privatePostAccountSetLeverage (params?: {}): Promise<Dict>;
    privatePostAccountPositionMarginBalance (params?: {}): Promise<Dict>;
    privatePostAccountSetFeeType (params?: {}): Promise<Dict>;
    privatePostAccountSetGreeks (params?: {}): Promise<Dict>;
    privatePostAccountSetIsolatedMode (params?: {}): Promise<Dict>;
    privatePostAccountSpotManualBorrowRepay (params?: {}): Promise<Dict>;
    privatePostAccountSetAutoRepay (params?: {}): Promise<Dict>;
    privatePostAccountQuickMarginBorrowRepay (params?: {}): Promise<Dict>;
    privatePostAccountBorrowRepay (params?: {}): Promise<Dict>;
    privatePostAccountSimulatedMargin (params?: {}): Promise<Dict>;
    privatePostAccountPositionBuilder (params?: {}): Promise<Dict>;
    privatePostAccountPositionBuilderGraph (params?: {}): Promise<Dict>;
    privatePostAccountSetRiskOffsetType (params?: {}): Promise<Dict>;
    privatePostAccountSetRiskOffsetAmt (params?: {}): Promise<Dict>;
    privatePostAccountActivateOption (params?: {}): Promise<Dict>;
    privatePostAccountSetAutoLoan (params?: {}): Promise<Dict>;
    privatePostAccountAccountLevelSwitchPreset (params?: {}): Promise<Dict>;
    privatePostAccountSetAccountLevel (params?: {}): Promise<Dict>;
    privatePostAccountSetCollateralAssets (params?: {}): Promise<Dict>;
    privatePostAccountMmpReset (params?: {}): Promise<Dict>;
    privatePostAccountMmpConfig (params?: {}): Promise<Dict>;
    privatePostAccountFixedLoanBorrowingOrder (params?: {}): Promise<Dict>;
    privatePostAccountFixedLoanAmendBorrowingOrder (params?: {}): Promise<Dict>;
    privatePostAccountFixedLoanManualReborrow (params?: {}): Promise<Dict>;
    privatePostAccountFixedLoanRepayBorrowingOrder (params?: {}): Promise<Dict>;
    privatePostAccountMovePositions (params?: {}): Promise<Dict>;
    privatePostAccountSetAutoEarn (params?: {}): Promise<Dict>;
    privatePostAccountSetSettleCurrency (params?: {}): Promise<Dict>;
    privatePostAccountSetTradingConfig (params?: {}): Promise<Dict>;
    privatePostAccountDemoAdjustBalance (params?: {}): Promise<Dict>;
    privatePostAssetSubaccountTransfer (params?: {}): Promise<Dict>;
    privatePostAccountSubaccountSetLoanAllocation (params?: {}): Promise<Dict>;
    privatePostUsersSubaccountCreateSubaccount (params?: {}): Promise<Dict>;
    privatePostUsersSubaccountApikey (params?: {}): Promise<Dict>;
    privatePostUsersSubaccountModifyApikey (params?: {}): Promise<Dict>;
    privatePostUsersSubaccountSubaccountApikey (params?: {}): Promise<Dict>;
    privatePostUsersSubaccountDeleteApikey (params?: {}): Promise<Dict>;
    privatePostUsersSubaccountSetTransferOut (params?: {}): Promise<Dict>;
    privatePostTradingBotGridOrderAlgo (params?: {}): Promise<Dict>;
    privatePostTradingBotGridCopyOrderAlgo (params?: {}): Promise<Dict>;
    privatePostTradingBotGridAmendAlgoBasicParam (params?: {}): Promise<Dict>;
    privatePostTradingBotGridAmendOrderAlgo (params?: {}): Promise<Dict>;
    privatePostTradingBotGridStopOrderAlgo (params?: {}): Promise<Dict>;
    privatePostTradingBotGridClosePosition (params?: {}): Promise<Dict>;
    privatePostTradingBotGridCancelCloseOrder (params?: {}): Promise<Dict>;
    privatePostTradingBotGridOrderInstantTrigger (params?: {}): Promise<Dict>;
    privatePostTradingBotGridWithdrawIncome (params?: {}): Promise<Dict>;
    privatePostTradingBotGridComputeMarginBalance (params?: {}): Promise<Dict>;
    privatePostTradingBotGridMarginBalance (params?: {}): Promise<Dict>;
    privatePostTradingBotGridMinInvestment (params?: {}): Promise<Dict>;
    privatePostTradingBotGridAdjustInvestment (params?: {}): Promise<Dict>;
    privatePostTradingBotSignalCreateSignal (params?: {}): Promise<Dict>;
    privatePostTradingBotSignalOrderAlgo (params?: {}): Promise<Dict>;
    privatePostTradingBotSignalStopOrderAlgo (params?: {}): Promise<Dict>;
    privatePostTradingBotSignalMarginBalance (params?: {}): Promise<Dict>;
    privatePostTradingBotSignalAmendTPSL (params?: {}): Promise<Dict>;
    privatePostTradingBotSignalSetInstruments (params?: {}): Promise<Dict>;
    privatePostTradingBotSignalClosePosition (params?: {}): Promise<Dict>;
    privatePostTradingBotSignalSubOrder (params?: {}): Promise<Dict>;
    privatePostTradingBotSignalCancelSubOrder (params?: {}): Promise<Dict>;
    privatePostTradingBotRecurringOrderAlgo (params?: {}): Promise<Dict>;
    privatePostTradingBotRecurringAmendOrderAlgo (params?: {}): Promise<Dict>;
    privatePostTradingBotRecurringStopOrderAlgo (params?: {}): Promise<Dict>;
    privatePostTradingBotDcaCreate (params?: {}): Promise<Dict>;
    privatePostTradingBotDcaAmendOrderAlgo (params?: {}): Promise<Dict>;
    privatePostTradingBotDcaStop (params?: {}): Promise<Dict>;
    privatePostTradingBotDcaOrdersManualBuy (params?: {}): Promise<Dict>;
    privatePostTradingBotDcaSettingsReinvestment (params?: {}): Promise<Dict>;
    privatePostTradingBotDcaSettingsTakeProfit (params?: {}): Promise<Dict>;
    privatePostTradingBotDcaMarginAdd (params?: {}): Promise<Dict>;
    privatePostTradingBotDcaMarginReduce (params?: {}): Promise<Dict>;
    privatePostTradingBotRecurringAddInvestment (params?: {}): Promise<Dict>;
    privatePostTradingBotRecurringAmendPriceRange (params?: {}): Promise<Dict>;
    privatePostTradingBotRecurringAmendRecurringAmount (params?: {}): Promise<Dict>;
    privatePostTradingBotRecurringAmendRecurringTime (params?: {}): Promise<Dict>;
    privatePostTradingBotRecurringPause (params?: {}): Promise<Dict>;
    privatePostTradingBotRecurringRestart (params?: {}): Promise<Dict>;
    privatePostFinanceSavingsPurchaseRedempt (params?: {}): Promise<Dict>;
    privatePostFinanceSavingsSetLendingRate (params?: {}): Promise<Dict>;
    privatePostFinanceStakingDefiPurchase (params?: {}): Promise<Dict>;
    privatePostFinanceStakingDefiRedeem (params?: {}): Promise<Dict>;
    privatePostFinanceStakingDefiCancel (params?: {}): Promise<Dict>;
    privatePostFinanceStakingDefiEthPurchase (params?: {}): Promise<Dict>;
    privatePostFinanceStakingDefiEthRedeem (params?: {}): Promise<Dict>;
    privatePostFinanceStakingDefiEthCancelRedeem (params?: {}): Promise<Dict>;
    privatePostFinanceStakingDefiSolPurchase (params?: {}): Promise<Dict>;
    privatePostFinanceStakingDefiSolRedeem (params?: {}): Promise<Dict>;
    privatePostFinanceStakingDefiSolCancelRedeem (params?: {}): Promise<Dict>;
    privatePostFinanceFlexibleLoanMaxLoan (params?: {}): Promise<Dict>;
    privatePostFinanceFlexibleLoanAdjustCollateral (params?: {}): Promise<Dict>;
    privatePostFinanceFlexibleLoanBorrow (params?: {}): Promise<Dict>;
    privatePostFinanceFlexibleLoanRepay (params?: {}): Promise<Dict>;
    privatePostFinanceOkusdSubscribe (params?: {}): Promise<Dict>;
    privatePostFinanceOkusdRedeem (params?: {}): Promise<Dict>;
    privatePostCopytradingAlgoOrder (params?: {}): Promise<Dict>;
    privatePostCopytradingCloseSubposition (params?: {}): Promise<Dict>;
    privatePostCopytradingSetInstruments (params?: {}): Promise<Dict>;
    privatePostCopytradingAmendProfitSharingRatio (params?: {}): Promise<Dict>;
    privatePostCopytradingFirstCopySettings (params?: {}): Promise<Dict>;
    privatePostCopytradingAmendCopySettings (params?: {}): Promise<Dict>;
    privatePostCopytradingStopCopyTrading (params?: {}): Promise<Dict>;
    privatePostCopytradingBatchSetLeverage (params?: {}): Promise<Dict>;
    privatePostBrokerNdCreateSubaccount (params?: {}): Promise<Dict>;
    privatePostBrokerNdDeleteSubaccount (params?: {}): Promise<Dict>;
    privatePostBrokerNdSubaccountApikey (params?: {}): Promise<Dict>;
    privatePostBrokerNdSubaccountModifyApikey (params?: {}): Promise<Dict>;
    privatePostBrokerNdSubaccountDeleteApikey (params?: {}): Promise<Dict>;
    privatePostBrokerNdSetSubaccountLevel (params?: {}): Promise<Dict>;
    privatePostBrokerNdSetSubaccountFeeRate (params?: {}): Promise<Dict>;
    privatePostBrokerNdSetSubaccountAssets (params?: {}): Promise<Dict>;
    privatePostAssetBrokerNdSubaccountDepositAddress (params?: {}): Promise<Dict>;
    privatePostAssetBrokerNdModifySubaccountDepositAddress (params?: {}): Promise<Dict>;
    privatePostBrokerNdRebatePerOrders (params?: {}): Promise<Dict>;
    privatePostFinanceSfpDcdQuote (params?: {}): Promise<Dict>;
    privatePostFinanceSfpDcdOrder (params?: {}): Promise<Dict>;
    privatePostFinanceSfpDcdTrade (params?: {}): Promise<Dict>;
    privatePostFinanceSfpDcdRedeemQuote (params?: {}): Promise<Dict>;
    privatePostFinanceSfpDcdRedeem (params?: {}): Promise<Dict>;
    privatePostBrokerNdReportSubaccountIp (params?: {}): Promise<Dict>;
    privatePostBrokerDmaSubaccountApikey (params?: {}): Promise<Dict>;
    privatePostBrokerDmaTrades (params?: {}): Promise<Dict>;
    privatePostBrokerFdRebatePerOrders (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
